<app-modal></app-modal>
<app-loading-overlay></app-loading-overlay>
<div *ngIf="mounted()">
  <router-outlet></router-outlet>
</div>
